import React, { useState } from 'react';
import styled from 'styled-components';
import { white, gray200, gray900, defaultDropShadow } from 'constants/colors';
import { useHeader } from './hooks';
import ConfirmModal from 'components/Modals/ConfirmModal';
import { isDeveloperMode } from 'utils/isDeveloperMode';

type PropsType = {
  isVisible: boolean;
};

const AccountMenu: React.FC<PropsType> = ({ isVisible }) => {
  const { t, onClickLogout, onClickLogoutAndClearStorge } = useHeader();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <ConfirmModal
        isOpen={isModalOpen}
        onToggle={() => setIsModalOpen(false)}
        title={t('confirm')}
        leftButtonText={t('cancel')}
        rightButtonText={t('ok')}
        onLeft={() => setIsModalOpen(false)}
        onRight={onClickLogoutAndClearStorge}
        size={'2xlg'}
      >
        <h6>{t('questionAboutLogoutAndClear')}</h6>
      </ConfirmModal>
      <MenuItemsContainer $isVisible={isVisible}>
        <MenuItem onClick={onClickLogout}>{t('logout')}</MenuItem>
        {isDeveloperMode && (
          <MenuItem onClick={() => setIsModalOpen(true)}>
            {t('logoutAndClearStorage')}
          </MenuItem>
        )}
      </MenuItemsContainer>
    </>
  );
};

type ContainerProps = {
  $isVisible: boolean;
};
const MenuItemsContainer = styled.ul<ContainerProps>`
  position: absolute;
  top: 100%;
  right: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
  color: ${gray900};
  list-style: none;
  box-shadow: 0px 0px 8px 0px ${defaultDropShadow};
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
  opacity: ${({ $isVisible }) => ($isVisible ? '1' : '0')};
  transition: all 0.2s ease;
`;

const MenuItem = styled.li`
  padding: 10px 20px;
  background-color: ${white};

  &:hover {
    background-color: ${gray200};
    cursor: pointer;
  }
`;

export default AccountMenu;
